export const clearStorage = () => {
  const clear = () => {
    localStorage.removeItem('session')
    localStorage.removeItem('rt')
    sessionStorage.clear()
  }

  return { clear }
}
